/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { customerValidateBillingDetails } from '../../axios/customerValidateBillingDetails'
import type {
	CustomerValidateBillingDetailsError,
	CustomerValidateBillingDetailsPathParams,
	CustomerValidateBillingDetailsQueryParams,
	CustomerValidateBillingDetailsResponse,
} from '../../types/CustomerValidateBillingDetails'

export const customerValidateBillingDetailsQueryKey = (
	organisation: CustomerValidateBillingDetailsPathParams['organisation'],
	params?: CustomerValidateBillingDetailsQueryParams,
) => [
	{ url: '/:organisation/customer/validate-billing', params: { organisation } },
	...(params ? [params] : []),
] as const

export type CustomerValidateBillingDetailsQueryKey = ReturnType<typeof customerValidateBillingDetailsQueryKey>

/** @see backend/nexus/modules/Billing/Http/Controllers/CustomerController.php CustomerController::validateBillingDetails */
export function customerValidateBillingDetailsQueryOptions(
	organisation: CustomerValidateBillingDetailsPathParams['organisation'],
	params?: CustomerValidateBillingDetailsQueryParams,
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		CustomerValidateBillingDetailsResponse,
		AxiosError<CustomerValidateBillingDetailsError>,
		CustomerValidateBillingDetailsResponse,
		CustomerValidateBillingDetailsQueryKey
	>({
		queryKey: customerValidateBillingDetailsQueryKey(organisation, params),
		queryFn: ({ signal }) =>
			customerValidateBillingDetails(organisation, params, { signal, ...config }).then(res => res.data),
		enabled: !!organisation,
	})
}

/** @see backend/nexus/modules/Billing/Http/Controllers/CustomerController.php CustomerController::validateBillingDetails */
export function useCustomerValidateBillingDetails<TSelectData = CustomerValidateBillingDetailsResponse>(
	organisation: CustomerValidateBillingDetailsPathParams['organisation'],
	params?: CustomerValidateBillingDetailsQueryParams,
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					CustomerValidateBillingDetailsResponse,
					AxiosError<CustomerValidateBillingDetailsError>,
					TSelectData,
					CustomerValidateBillingDetailsQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<CustomerValidateBillingDetailsError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...customerValidateBillingDetailsQueryOptions(organisation, params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Billing/Http/Controllers/CustomerController.php CustomerController::validateBillingDetails */
export function useCustomerValidateBillingDetailsSuspense<TSelectData = CustomerValidateBillingDetailsResponse>(
	organisation: CustomerValidateBillingDetailsPathParams['organisation'],
	params?: CustomerValidateBillingDetailsQueryParams,
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					CustomerValidateBillingDetailsResponse,
					AxiosError<CustomerValidateBillingDetailsError>,
					TSelectData,
					CustomerValidateBillingDetailsQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<CustomerValidateBillingDetailsError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...customerValidateBillingDetailsQueryOptions(organisation, params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
